import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { SavedCriteria } from '../../models/saved-filters.model';
import { baseQuery } from './base.query';
import { UserDataType } from '../../models/user.model';
import { GridConfig } from '../../models/grid-config.model';
import { WidgetOptions } from 'common/contexts/useWidgetOptionsContext';

export type UserDataTypeResult = SavedCriteria | GridConfig | WidgetOptions;

export function toDataTypeResult<T>(value: T) {
  return value as UserDataTypeResult;
}

export function parseDataTypeResult<T>(value: UserDataTypeResult) {
  return value as T;
}

export const userDataApi = createApi({
  reducerPath: 'userDataApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getUserDataList: builder.query<
      { key: number; value: UserDataTypeResult }[] | undefined,
      { type: UserDataType; projectId?: string }
    >({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_DATA}/list/${args.type}`,
      }),
    }),
    createUserDataRow: builder.mutation<
      number[],
      { userDataTypeId: UserDataType; data: UserDataTypeResult }
    >({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_DATA}`,
        method: 'POST',
        body: {
          ...args,
          userTypeId: args.userDataTypeId,
        },
      }),
    }),
    updateUserDataRow: builder.mutation<
      unknown,
      { userDataTypeId: UserDataType; key: number; data: UserDataTypeResult }
    >({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_DATA}/${args.key}`,
        method: 'PUT',
        body: {
          ...args,
          userTypeId: args.userDataTypeId,
        },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    deleteUserDataRow: builder.mutation<unknown, number>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.USER_DATA}/${args.toString()}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetUserDataListQuery,
  useDeleteUserDataRowMutation,
  useCreateUserDataRowMutation,
  useUpdateUserDataRowMutation,
} = userDataApi;
